import { formatDate } from 'shared/functions';

export const esgPortfoliosToTableParser = data => {
  return data.map(item => [
    item.id,
    [item.id, item.name, item.description, item.isDedicated],
    item.noOfItems,
    formatDate(item.createdDate),
    formatDate(item.modifiedDate),
    null,
  ]);
};
